import { toast } from 'react-toastify';

const showErrorToast = (message: string) => {
  return toast.error(message, {
    position: 'bottom-center',
    autoClose: 10000,
    theme: 'light',
  });
};

const showSuccessToast = (message: string) => {
  return toast.success(message, {
    position: 'bottom-center',
    autoClose: 3000,
    theme: 'light',
  });
};

const showInfoToast = (message: string) => {
  return toast.info(message, {
    position: 'bottom-center',
    autoClose: 6000,
    theme: 'light',
  });
};

const showWarningToast = (message: string) => {
  return toast.warn(message, {
    position: 'bottom-center',
    autoClose: 5000,
    theme: 'light',
  });
};

export { showErrorToast, showInfoToast, showSuccessToast, showWarningToast };
